import { useEffect, useState } from "react";
import { Comp, League, PublicApiService, Statistics } from "../services/publiApiService";
import { FishingDiscipline, formatKg, useFishingDiscipline, disciplineLabel } from "../types/fishingDiscipline";
import PublicDisciplineLayout from "../components/publicSite/PublicDisciplineLayout";

export default function PublicStatsPage() {
  const discipline = useFishingDiscipline();
  const carp = discipline === FishingDiscipline.CarpAndCrucian;
  const [competitors, setCompetitors] = useState<Comp[]>([]);
  const [leagues, setLeagues] = useState<League[]>([]);
  const [competitor, setCompetitor] = useState("");
  const [league, setLeague] = useState("");
  const [stats, setStats] = useState<Statistics | null>(null);
  const [loading, setLoading] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setLoadingFilters(true); setError("");
    Promise.all([PublicApiService.getCompetitors(discipline), PublicApiService.getLeagues(discipline)])
      .then(([people, championships]) => { if (!active) return; setCompetitors(people); setLeagues(championships.results); })
      .catch(e => { if (active) setError(e.message || "Impossibile caricare i filtri."); })
      .finally(() => { if (active) setLoadingFilters(false); });
    return () => { active = false; };
  }, [discipline]);
  useEffect(() => {
    if (!competitor) { setStats(null); return; }
    let active = true;
    setLoading(true); setError(""); setStats(null);
    PublicApiService.getRanking(Number(competitor), league ? Number(league) : null, null, discipline)
      .then(result => { if (active) setStats(result); })
      .catch(e => { if (active) setError(e.message || "Impossibile caricare le statistiche."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [competitor, league, discipline]);
  const selectedCompetitor = competitors.find(person => String(person.id) === competitor);
  return <PublicDisciplineLayout title={`Statistiche ${disciplineLabel(discipline)}`} intro="Consulta i risultati di un concorrente, in una stagione o in tutti i campionati.">
    <div className="site-filters site-filters--two">
    <label className="site-field"><span>Concorrente</span>
      <select value={competitor} disabled={loadingFilters} onChange={e => setCompetitor(e.target.value)}>
        <option value="">Seleziona un concorrente</option>{competitors.map(c => <option key={c.id} value={c.id}>{c.lastName} {c.firstName}</option>)}
      </select>
    </label>
      <label className="site-field"><span>Campionato</span>
        <select disabled={loadingFilters} value={league} onChange={e => setLeague(e.target.value)}>
          <option value="">Tutti i campionati</option>{leagues.map(l => <option key={l.id} value={l.id}>{l.name} ({l.year})</option>)}
        </select>
      </label>
    </div>
    {error && <p role="alert" className="site-notice site-notice--error">{error}</p>}
    {(loading || loadingFilters) && <p role="status" className="site-notice">{loadingFilters ? "Caricamento concorrenti e campionati…" : "Caricamento statistiche…"}</p>}
    {!loadingFilters && !competitor && !error && <p className="site-notice">Seleziona un concorrente per vedere gare disputate, podi e risultati.</p>}
    {stats && <section aria-label="Statistiche del concorrente" className="stats-summary">
      <h2>{selectedCompetitor ? `${selectedCompetitor.lastName} ${selectedCompetitor.firstName}` : "Risultati del concorrente"}</h2>
      <dl className="stats-metrics">
        {[["Gare disputate", stats.competitionsCount], [carp ? "Peso totale pescato" : "Trote pescate", carp ? `${formatKg(stats.totalWeightKg ?? 0)} kg` : stats.totalFish], ["Punti totali", stats.totalPoints]].map(([label, value]) =>
          <div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}
      </dl>
      <dl className="stats-podium" aria-label="Dettaglio podi">
        {[["Primi posti", "🥇", stats.firstPlaces], ["Secondi posti", "🥈", stats.secondPlaces], ["Terzi posti", "🥉", stats.thirdPlaces]].map(([label, medal, count]) => <div key={label}><dt><span aria-hidden="true" className="stats-podium__medal">{medal}</span>{label}</dt><dd>{count}</dd></div>)}
      </dl>
      {league && <dl className="stats-league">
        <div><dt>Posizione campionato</dt><dd>{stats.positionLeague != null ? `${stats.positionLeague}°` : "—"}</dd></div>
        <div><dt>Punti campionato</dt><dd>{stats.pointLeague ?? 0}</dd></div>
      </dl>}
      {stats.competitionsCount === 0 && <p className="site-note mt-6">Nessuna gara disputata per i filtri selezionati.</p>}
    </section>}
  </PublicDisciplineLayout>;
}
